import {
  CREATE_ASSET_READING_SUCCESS,
  FETCH_ASSET_LAST_READING_SUCCESS,
  FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS,
  FETCH_ASSET_READING_SUCCESS,
  FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS,
  GET_ASSET_READING_SUCCESS,
  SAVE_ASSET_READING_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  lastReading: null,
  lastReadingWithTime: null,
  verificationReadingRecord: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_READING_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ASSET_READING_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ASSET_READING_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ASSET_READING_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    case FETCH_ASSET_LAST_READING_SUCCESS: {
      return {
        ...state,
        lastReading: action.data,
      }
    } case FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS: {
      return {
        ...state,
        lastReadingWithTime: action.data,
      }
    }

    case FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS: {
      return {
        ...state,
        verificationReadingRecord: action.data,
      }
    }


    default:
      return state;
  }
}
